/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { jsx } from '@atlaskit/css';
import LightbulbIcon from '@atlaskit/icon/core/lightbulb';
import SprintIcon from '@atlaskit/icon/core/sprint';

import type { CyphieMode } from '../../../../../../../state/LabsAtoms';

type ModeIconProps = {
	mode: CyphieMode;
};

export const ModeIcon = ({ mode }: ModeIconProps): JSX.Element => {
	return mode === 'reasoning' ? (
		<LightbulbIcon label="" size="small" />
	) : (
		<SprintIcon label="" size="small" />
	);
};
